/**
 * 智能网联服务
 */
export default [
  {
    path: '/intelligentService-recharge-:vinNo',
    component: () => import('@/views/intelligentService/Recharge.vue'),
    name: 'intelligentService-recharge',
    meta: {
      title: '智能服务充值',
      backgroundClass: 'bg-gray',
      hideNaginationBar: false,
    },
  },
  {
    path: '/intelligentService-record-:vinNo',
    component: () => import('@/views/intelligentService/Record.vue'),
    name: 'intelligentService-record',
    meta: {
      title: '充值记录',
      backgroundClass: 'bg-gray',
      hideNaginationBar: false,
    },
  },
];
